import clsx from 'clsx'
import globalMU from 'globalMU'
import * as R from 'ramda'
import React, { useEffect, useRef, useState } from 'react'

const estilosInput = require('../../estilos/inputs.module.scss').default

export type InputNumericoProps = {
    valor?: number
    onValorModificado?: (valor?: number) => void
    numeroCasasDecimais?: number
    disabled?: boolean
    classesInput?: string[]
    selecionaValorOnFocus?: boolean
    campoNullavel?: boolean
    alinharADireita?: boolean
    style?: React.CSSProperties
    onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void
    id?: string
    naoExibirValorZero?: boolean
    title?: string
    name?: string
    teclaDeAtalho?: string
    permitirValorNegativo?: boolean // 440122
    autoFocus?: boolean
    pattern?: string // 477329
    ocorreuDesvio?: number
}

export const InputNumerico = (props: InputNumericoProps) => {
    const [valor, setValor] = useState(globalMU.formatarValorNumerico(props.valor ?? 0, props.numeroCasasDecimais ?? 2))
    const [focoInicial, setFocoInicial] = useState(false)

    // React 19: `useRef` passou a exigir o valor inicial explicito (nao ha mais a sobrecarga sem
    // argumento). `null` e o equivalente para uma ref de elemento do DOM.
    const ref = useRef<HTMLInputElement>(null)
    const dirtyRef = useRef(false)

    useEffect(() => {
        props.valor == null && props.campoNullavel ? setValor(null) : setValor(globalMU.formatarValorNumerico(props.valor ?? 0, props.numeroCasasDecimais ?? 2))
    }, [props.valor, props.ocorreuDesvio])

    useEffect(() => {
        if (focoInicial) {
            ref.current.select()
            setFocoInicial(false)
        } 
    }, [valor])


    const confirmarAlteracaoValor = () => {

        const valorN = globalMU.isNullOrEmpty(valor) ? 0 : Number(valor.replace(",", "."))
        setValor(globalMU.formatarValorNumerico(valorN, props.numeroCasasDecimais ?? 2))

        props.onValorModificado?.(valor == null && props.campoNullavel ? null : valorN)

        dirtyRef.current = false
    }

    const teclaDigitadaEhValida = (tecla: string): boolean => {

        const regexTeclasValidas = /[0-9\-,\.]/

        const numeroDeCasasDecimaisDigitadas = () => {
            const valorAjustado = (valor ?? "").replace(",", ".")
            const indiceSeparador = valorAjustado.indexOf(".")

            return indiceSeparador == -1 ? 0 : valorAjustado.substring(indiceSeparador, valorAjustado.length).length
        }

        const textoTotalmenteSelecionado = () => {
            return ref.current.selectionStart == 0 && ref.current.selectionEnd == (valor?.length ?? 0)
        }

        return textoTotalmenteSelecionado() ? true :
            valor?.includes(",") && (tecla == "," || tecla == ".") ? false :
                valor?.includes(".") && (tecla == "," || tecla == ".") ? false :
                    globalMU.isNotNullOrEmpty(valor) && tecla == "-" ? false :
                        valor?.includes("-") && tecla == "-" ? false :
                            numeroDeCasasDecimaisDigitadas() == props.numeroCasasDecimais + 1 ? false :
                                regexTeclasValidas.test(tecla)
    }

    return <>
        <input
            id={props.id}
            className={clsx(estilosInput.inputPadrao, "no-global-input", props.classesInput)}
            style={{
                ...(props.style != null ? props.style : {}),
                ...({ textAlign: R.includes(props.alinharADireita, [null, undefined, true]) ? 'right' : 'left' })
            }}
            ref={ref}
            accessKey={props.teclaDeAtalho}
            onKeyPress={(event) => {

                if (!teclaDigitadaEhValida(event.key)) {
                    event.preventDefault()
                }

            }}
            inputMode="numeric" // mostrar no androi o teclado numerico 
            pattern={ props.pattern == "" ? undefined : props.pattern ?? "[0-9]*"} // 477329 mostrar no androi o teclado numerico
            disabled={props.disabled === true}
            value={props.naoExibirValorZero && Number(valor) == 0 ? "" : valor ?? ""}
            alt={props.title}
            title={props.title}
            name={props.name}
            autoComplete="off"
            aria-autocomplete="none"
            onChange={e => {

                const valorAjustado = props.permitirValorNegativo  == null || props.permitirValorNegativo // 440122
                    ? e.target.value.replace(/[^0-9-,.]/g, '')
                    : e.target.value.replace(/[^0-9,.]/g, '')

                e.target.value == "" ? setValor(null) :
                    setValor(valorAjustado) // 455714
                dirtyRef.current = true

            }}
            onKeyDown={e => {
                setFocoInicial(false)
                props.onKeyDown?.(e)

                if (dirtyRef.current && R.includes(e.code, ["Enter", "NumpadEnter", "Tab"])) {
                    confirmarAlteracaoValor()
                }
            }}
            autoFocus={props.autoFocus}

            onBlur={() => {
                if (dirtyRef.current) {
                    confirmarAlteracaoValor()
                }
            }}
            onFocus={(e) => { setFocoInicial(true), (R.includes(props.selecionaValorOnFocus, [null, undefined, true]) ? e.target.select() : null) }}
        />
    </>
}